<clr-modal [(clrModalOpen)]="isOpen" [clrModalSize]="isFullScreen() ? 'full-screen' : 'xl'" [clrModalClosable]="false">
  <h3 class="modal-title d-f gap-25 clr-form-horizontal width100 clr-align-items-center">
    {{ 'Weichenmessdaten importieren' | mrTranslate }}
    <clr-select-container class="nm">
      <label class="clr-col-2">
        @if (symbol; as symbol) {
          <cds-icon class="fill-black grid-icon" [shape]="'objekttyp' + symbol" size="22" />
        }
      </label>
      <select clrSelect [(ngModel)]="otypid">
        @for (name of sotyp; track name.id) {
          <option [value]="+name.id">{{ name.bezeichnung }}</option>
        }
      </select>
    </clr-select-container>
  </h3>

  <div class="modal-body">
    <form clrForm class="width100 clr-row nxm no-margin" [clrLabelSize]="5">
      <clr-select-container class="clr-col-4">
        <label>{{ 'Messgerät' | mrTranslate }}</label>
        <select
          clrSelect
          [(ngModel)]="selectedMessgeraet"
          (ngModelChange)="onOptionsSelected($event)"
          [ngModelOptions]="{ standalone: true }">
          <option value="Messprofil V3.0">Messprofil V3.0</option>
          <option value="Messprofil XML">Messprofil XML</option>
          <option value="Cemafer SGMT5">Cemafer SGMT5</option>
          <option value="Diamont S2">Diamont S2</option>
        </select>
      </clr-select-container>
      <clr-radio-container clrInline class="clr-col-5">
        <label>{{ 'Toleranzenauswahl' | mrTranslate }}</label>
        <clr-radio-wrapper>
          <label>{{ 'Regelinspektion' | mrTranslate }}</label>
          <input type="radio" clrRadio name="isNeuTol" [value]="false" [(ngModel)]="isNeuTol" />
        </clr-radio-wrapper>
        <clr-radio-wrapper>
          <label>{{ 'Neu' | mrTranslate }}</label>
          <input type="radio" clrRadio name="isNeuTol" [value]="true" [(ngModel)]="isNeuTol" />
        </clr-radio-wrapper>
      </clr-radio-container>
      <div id="fieldset-container" class="clr-col-9 margin-12-t">
        @let tol = messtol.value;

        <fieldset class="padding-6 margin--6-l margin-12-t clr-row margin-0-r clr-align-items-center">
          <clr-checkbox-container clrInline class="clr-col nxp">
            <label>{{ 'Optionen' | mrTranslate }}</label>
            <clr-checkbox-wrapper>
              <label>{{ 'Bezeichnung als Großbuchstaben' | mrTranslate }}</label>
              <input type="checkbox" clrCheckbox name="isGross" [(ngModel)]="isGrossBuchstaben" />
            </clr-checkbox-wrapper>
            <clr-checkbox-wrapper class="clr-offset-1">
              <label>{{ 'IIS Daten' | mrTranslate }}</label>
              <input type="checkbox" clrCheckbox name="isIIS" [(ngModel)]="isIIS" />
            </clr-checkbox-wrapper>
          </clr-checkbox-container>
        </fieldset>
        <fieldset class="padding-6 margin--6-l margin-12-t clr-row margin-0-r clr-align-items-center">
          <span class="clr-control-label clr-col-5 nxp">
            {{ isNeuTol() ? 'Toleranzen' : ('Auswertung' | mrTranslate) }}
          </span>
          <div class="clr-row nxm clr-col nxp" cds-layout="gap:xxxl">
            @if (!isNeuTol()) {
              @if (tol.USE_100) {
                <div class="round-border padding-3" [style.--border-color]="tol.COLOR_100">
                  <cds-icon shape="check" />
                  {{ tol.TEXT_100_S }}
                </div>
              }
              @if (tol.USE_L) {
                <div class="round-border padding-3" [style.--border-color]="tol.COLOR_L">
                  <cds-icon shape="check" />
                  {{ tol.TEXT_L_S }}
                </div>
              }
              @if (tol.USE_G) {
                <div class="round-border padding-3" [style.--border-color]="tol.COLOR_G">
                  <cds-icon shape="check" />
                  {{ tol.TEXT_G_S }}
                </div>
              }
            } @else {
              <div class="round-border padding-3" [style.--border-color]="tol.COLOR_0">
                <cds-icon shape="check" />
                {{ tol.TEXT_0_S }}
              </div>
              <clr-checkbox-wrapper>
                <label>{{ 'Vorabnahme (ohne Überhöhung)' | mrTranslate }}</label>
                <input type="checkbox" clrCheckbox name="ohneUeberh" [(ngModel)]="ohneUeberhoehung" />
              </clr-checkbox-wrapper>
            }
          </div>
        </fieldset>
        <fieldset class="padding-6 margin--6-l margin-12-t clr-row margin-0-r clr-align-items-center">
          <clr-radio-container clrInline class="clr-col nxp">
            <label>{{ 'Durchfahrrillen' | mrTranslate }}</label>
            <clr-radio-wrapper>
              <label>{{ 'Messreg' | mrTranslate }}</label>
              <input type="radio" clrRadio name="optionsD" [value]="false" [(ngModel)]="optionsD" />
            </clr-radio-wrapper>
            <clr-radio-wrapper>
              <label>&ge;</label>
              <input type="radio" clrRadio name="optionsD" [value]="true" [(ngModel)]="optionsD" />
            </clr-radio-wrapper>
          </clr-radio-container>
        </fieldset>
        <fieldset class="padding-6 margin--6-l margin-12-t clr-row margin-0-r clr-align-items-center">
          <clr-radio-container clrInline class="clr-col nxp">
            <label>{{ 'Leitkantenabstand' | mrTranslate }}</label>
            <clr-radio-wrapper>
              <label>{{ 'Messreg' | mrTranslate }}</label>
              <input type="radio" clrRadio name="optionsLK" [value]="false" [(ngModel)]="optionsLK" />
            </clr-radio-wrapper>
            <clr-radio-wrapper>
              <label>&le;</label>
              <input type="radio" clrRadio name="optionsLK" [value]="true" [(ngModel)]="optionsLK" />
            </clr-radio-wrapper>
          </clr-radio-container>
        </fieldset>
        <fieldset class="padding-6 margin--6-l margin-12-t clr-row margin-0-r clr-align-items-center">
          <clr-radio-container clrInline class="clr-col nxp">
            <label>{{ 'Toleranz-Text' | mrTranslate }}</label>
            <clr-radio-wrapper>
              <label>{{ 'Messreg' | mrTranslate }}</label>
              <input type="radio" clrRadio name="isCustomText" [value]="false" [(ngModel)]="isCustomText" />
            </clr-radio-wrapper>
            <clr-radio-wrapper>
              <label style="display: inline-flex" class="gap-15">
                {{ 'Andere' | mrTranslate }}
                @if (isCustomText()) {
                  <clr-input-container style="margin-top: -4px">
                    <label hidden></label>
                    <input type="text" clrInput class="clr-col-12" name="customText" [(ngModel)]="customText" />
                  </clr-input-container>
                }
              </label>
              <input type="radio" clrRadio name="isCustomText" [value]="true" [(ngModel)]="isCustomText" />
            </clr-radio-wrapper>
          </clr-radio-container>
        </fieldset>
      </div>

      <div class="clr-col upload-container" (uploadDropzone)="onDrop($event)" (click)="fileInput.click()">
        <h4>{{ 'Hochladen' | mrTranslate }}</h4>
        <cds-icon shape="cloud" size="72" />
        <p>{{ 'Klicken oder ziehen Sie die Datei in diesen Bereich' | mrTranslate }}</p>
      </div>
    </form>
    <clr-accordion class="margin-12-t margin-9-lr">
      <clr-accordion-panel class="content-padding" style="--padding: 12px">
        <clr-accordion-title>{{ 'Einstellungen' | mrTranslate }}</clr-accordion-title>
        <clr-accordion-content>
          <form
            clrForm
            [formGroup]="messtol"
            class="no-margin width100"
            clrLayout="vertical"
            (ngSubmit)="saveSettings()">
            <div class="grid margin-12-t gap-15" id="settings-grid">
              <span class="clr-control-label">{{ 'Feld' | mrTranslate }}</span>
              <span class="clr-control-label">{{ 'Bezeichnung' | mrTranslate }}</span>
              <span class="clr-control-label">{{ 'Farbe' | mrTranslate }}</span>
              <span class="clr-control-label">{{ 'Auswerten' | mrTranslate }}</span>
              <span class="clr-control-label span-2">{{ 'Überschrift' | mrTranslate }}</span>
              <span class="clr-control-label">{{ 'Ausfall' | mrTranslate }}</span>

              <span class="clr-control-label">GW5</span>
              <clr-input-container>
                <input type="text" clrInput formControlName="TEXT_0_S" />
              </clr-input-container>
              <clr-control-container>
                <app-color-input formControlName="COLOR_0" />
              </clr-control-container>
              <!-- <div role="grid-cell-placeholder" aria-hidden="true"></div> -->
              <clr-checkbox-container>
                <clr-checkbox-wrapper>
                  <input type="checkbox" clrCheckbox formControlName="USE_0" />
                </clr-checkbox-wrapper>
              </clr-checkbox-container>
              <clr-input-container>
                <input type="text" clrInput formControlName="TEXT_0_m" />
              </clr-input-container>
              <clr-input-container>
                <input type="text" clrInput formControlName="TEXT_0_p" />
              </clr-input-container>
              <clr-input-container>
                <input clrInput formControlName="TEXT_0_A" />
              </clr-input-container>

              <span class="clr-control-label">GW1</span>
              <clr-input-container>
                <input type="text" clrInput formControlName="TEXT_100_S" />
              </clr-input-container>
              <clr-control-container>
                <app-color-input formControlName="COLOR_100" />
              </clr-control-container>
              <clr-checkbox-container>
                <clr-checkbox-wrapper>
                  <input type="checkbox" clrCheckbox formControlName="USE_100" />
                </clr-checkbox-wrapper>
              </clr-checkbox-container>
              <clr-input-container>
                <input type="text" clrInput formControlName="TEXT_100_m" />
              </clr-input-container>
              <clr-input-container>
                <input type="text" clrInput formControlName="TEXT_100_p" />
              </clr-input-container>
              <clr-input-container>
                <input clrInput formControlName="TEXT_100_A" />
              </clr-input-container>

              <span class="clr-control-label">GW2</span>
              <clr-input-container>
                <input type="text" clrInput formControlName="TEXT_L_S" />
              </clr-input-container>
              <clr-control-container>
                <app-color-input formControlName="COLOR_L" />
              </clr-control-container>
              <clr-checkbox-container>
                <clr-checkbox-wrapper>
                  <input type="checkbox" clrCheckbox formControlName="USE_L" />
                </clr-checkbox-wrapper>
              </clr-checkbox-container>
              <clr-input-container>
                <input type="text" clrInput formControlName="TEXT_L_m" />
              </clr-input-container>
              <clr-input-container>
                <input type="text" clrInput formControlName="TEXT_L_p" />
              </clr-input-container>
              <clr-input-container>
                <input clrInput formControlName="TEXT_L_A" />
              </clr-input-container>

              <span class="clr-control-label">GW3</span>
              <clr-input-container>
                <input type="text" clrInput formControlName="TEXT_G_S" />
              </clr-input-container>
              <clr-control-container>
                <app-color-input formControlName="COLOR_G" />
              </clr-control-container>
              <clr-checkbox-container>
                <clr-checkbox-wrapper>
                  <input type="checkbox" clrCheckbox formControlName="USE_G" />
                </clr-checkbox-wrapper>
              </clr-checkbox-container>
              <clr-input-container>
                <input type="text" clrInput formControlName="TEXT_G_m" />
              </clr-input-container>
              <clr-input-container>
                <input type="text" clrInput formControlName="TEXT_G_p" />
              </clr-input-container>
              <clr-input-container>
                <input clrInput formControlName="TEXT_G_A" />
              </clr-input-container>
            </div>

            <fieldset class="margin-12-t clr-row nxm gap-15">
              <clr-input-container class="clr-col nxp">
                <label>{{ 'Abnahmeinspektion' | mrTranslate }}</label>
                <input type="text" clrInput formControlName="TEXT_Ausfall_0" />
              </clr-input-container>
              <clr-input-container class="clr-col nxp">
                <label>{{ 'Regelinspektion' | mrTranslate }}</label>
                <input type="text" clrInput formControlName="TEXT_Ausfall_I" />
              </clr-input-container>
            </fieldset>

            <div class="margin-12-t">
              <button class="btn btn-primary btn-sm" type="submit" [disabled]="trial">
                {{ 'Speichern' | mrTranslate }}
              </button>
              <button
                type="button"
                class="btn btn-icon btn-sm btn-danger-outline float-right"
                (click)="messtol.reset()">
                <clr-tooltip>
                  <cds-icon clrTooltipTrigger shape="backup-restore" />
                  <clr-tooltip-content [clrPosition]="'top-left'" [clrSize]="'md'">
                    {{ 'Zurücksetzen' | mrTranslate }}
                  </clr-tooltip-content>
                </clr-tooltip>
              </button>
            </div>
          </form>
        </clr-accordion-content>
      </clr-accordion-panel>
    </clr-accordion>

    @if (switches().length) {
      <div class="clr-row">
        <div class="clr-col-5">
          <clr-datagrid class="datagrid-compact">
            <clr-dg-column>{{ 'Bezeichnung' | mrTranslate }}</clr-dg-column>
            <clr-dg-column>{{ 'Bereich' | mrTranslate }}</clr-dg-column>
            <clr-dg-column>{{ 'Typ' | mrTranslate }}</clr-dg-column>
            <clr-dg-column>{{ 'Prüfer' | mrTranslate }}</clr-dg-column>
            <clr-dg-column></clr-dg-column>

            @for (sw of switches(); track sw.id) {
              <clr-dg-row [class.datagrid-selected]="selectedSwitch()?.id === sw.id" (click)="selectSwitch(sw)">
                <!-- <clr-dg-cell>{{ sw.name }}</clr-dg-cell> -->
                <clr-dg-cell>
                  @let gemessen = getGemessen(sw);
                  @let percent = +((gemessen / sw.messpunkte.length) * 100).toFixed(1);

                  <div class="sw-inline">
                    <span class="sw-name">{{ sw.name }}</span>

                    <clr-progress-bar
                      [clrValue]="percent"
                      [clrColor]="
                        percent === 100.0 ? 'success'
                        : percent === 0 ? 'danger'
                        : 'warning'
                      "
                      clrLabeled></clr-progress-bar>
                  </div>
                </clr-dg-cell>

                <clr-dg-cell>{{ sw.location }}</clr-dg-cell>
                <clr-dg-cell>{{ sw.gemoetry }}</clr-dg-cell>
                <clr-dg-cell>
                  <clr-input-container style="margin-top: 15px">
                    <input
                      clrInput
                      [placeholder]="'Prüfer?' | mrTranslate"
                      name="input-{{ sw.id }}"
                      [(ngModel)]="sw.pruefer"
                      (ngModelChange)="checkPruefer()" />
                  </clr-input-container>
                </clr-dg-cell>
                <clr-dg-cell>
                  <button class="btn btn-danger btn-sm" (click)="deleteSwitch(sw.id); $event.stopPropagation()">
                    x
                  </button>
                </clr-dg-cell>
              </clr-dg-row>
            }
          </clr-datagrid>
        </div>
        <div class="clr-col-7">
          <clr-datagrid class="datagrid-compact">
            <clr-dg-column>{{ 'Bezeichnung' | mrTranslate }}</clr-dg-column>
            <clr-dg-column>{{ 'Soll' | mrTranslate }}</clr-dg-column>
            <clr-dg-column>{{ 'Ist' | mrTranslate }}</clr-dg-column>
            <clr-dg-column>{{ 'Ausfall' | mrTranslate }}</clr-dg-column>
            <clr-dg-column>{{ 'Info' | mrTranslate }}</clr-dg-column>
            <clr-dg-column>{{ 'Datum' | mrTranslate }}</clr-dg-column>

            @for (mp of selectedMpSet(); track mp.id) {
              <clr-dg-row>
                <clr-dg-cell>{{ mp.bezeichner }}</clr-dg-cell>
                <clr-dg-cell>{{ mp.soll }}</clr-dg-cell>

                @switch (mp.srwert) {
                  @case (-1) {
                    <clr-dg-cell>{{ 'n.g' | mrTranslate }}</clr-dg-cell>
                  }
                  @case (0)
                  @case (1)
                  @case (2)
                  @case (3)
                  @case (4)
                  @case (5) {
                    <clr-dg-cell>{{ mp.messwert }}</clr-dg-cell>
                  }

                  @default {
                    <clr-dg-cell>?</clr-dg-cell>
                  }
                }
                @switch (mp.srwert) {
                  @case (-1)
                  @case (0) {
                    <clr-dg-cell></clr-dg-cell>
                  }

                  @case (1) {
                    <clr-dg-cell>
                      <div
                        class="round-border padding-3"
                        [style.--border-color]="tol.COLOR_100"
                        [style.background-color]="tol.COLOR_100">
                        {{ tol.TEXT_100_S }}
                      </div>
                    </clr-dg-cell>
                  }

                  @case (2) {
                    <clr-dg-cell>
                      <div
                        class="round-border padding-3"
                        [style.--border-color]="tol.COLOR_L"
                        [style.background-color]="tol.COLOR_L">
                        {{ tol.TEXT_L_S }}
                      </div>
                    </clr-dg-cell>
                  }

                  @case (3) {
                    <clr-dg-cell>
                      <div
                        class="round-border padding-3"
                        [style.--border-color]="tol.COLOR_G"
                        [style.background-color]="tol.COLOR_G">
                        {{ tol.TEXT_G_S }}
                      </div>
                    </clr-dg-cell>
                  }

                  @case (4)
                  @case (5) {
                    <clr-dg-cell>
                      <div
                        class="round-border padding-3"
                        [style.--border-color]="tol.COLOR_0"
                        [style.background-color]="tol.COLOR_0">
                        {{ tol.TEXT_0_S }}
                      </div>
                    </clr-dg-cell>
                  }

                  @default {
                    <clr-dg-cell>?</clr-dg-cell>
                  }
                }

                <clr-dg-cell>{{ mp.mpinfo }}</clr-dg-cell>
                <clr-dg-cell>{{ mp.messdatum | date: 'dd.MM.yyyy HH:mm:ss' }}</clr-dg-cell>
              </clr-dg-row>
            }
          </clr-datagrid>
        </div>
      </div>
      <br />
    } @else {
      <div class="clr-col-4" style="padding-left: 5px">
        @if (filelistcount > 0) {
          <div class="d-f w-100-p margin-10-l margin-7-b">
            <h5>{{ 'Dateien' | mrTranslate }}{{ ': ' + filelistcount }}</h5>
          </div>
        }
        <ul>
          @for (mess of daten; track mess.filename) {
            <li>
              <span class="file-label" [ngStyle]="{ 'border-color': mess.error ? 'red' : '#8f9ba3' }">
                {{ mess.filename }}
                <a [title]="'Cancel' | mrTranslate" (click)="removeFileFromArray(mess)">
                  <cds-icon shape="times-circle" solid="true" />
                </a>
                @if (mess.error) {
                  <a href="..." role="tooltip" aria-haspopup="true" class="tooltip tooltip-lg">
                    <cds-icon shape="info-circle" size="22" />
                    <span class="tooltip-content">{{ mess.errortext }}</span>
                  </a>
                }
              </span>
            </li>
          }
        </ul>
      </div>
    }
  </div>
  <div class="modal-footer">
    @if (downloadingFile) {
      <div>
        <clr-spinner clrInline>Downloading</clr-spinner>
        <span>uploading</span>
      </div>
    }
    <button
      [disabled]="filelistcount == 0 || !allSwitchesHavePruefer"
      type="button"
      class="btn btn-primary"
      (click)="runUpload()">
      {{ 'OK' | mrTranslate }}
    </button>
    <button type="button" class="btn" (click)="doexit()">{{ 'Beenden' | mrTranslate }}</button>
  </div>
</clr-modal>

<input type="file" #fileInput multiple="multiple" [accept]="accept()" hidden (change)="onFileInputChange($event)" />
